export default a => a;
